/**
 * 提供一个配置好的axios，然后导出，不用到入main.js 在各个板块的文件夹中直接导入封住好的axios进行直接使用。
 * 使用示例请查看   api/
 */
import axios from "axios";
import JSONBIGINT from "json-bigint";
import { Message, MessageBox } from "element-ui";
//import router from "@/router/index";
import { get_token } from "@/utils/auth";
import { hide_loading, show_loading } from "@/utils/loading";
import Vue from "vue";
import Router from "vue-router";
import App from "../App";
Vue.use(Router);

const router = new Router({
  routes: [],
});
/**
 *  1. 默认配置
 */
//axios.defaults.baseURL = "https://api-admin.qhdjf.cn/";

axios.defaults.baseURL = "https://jf.seatopia.cn"

/**
 * 配置头部的代码不能在此处定义。
 * 这个里的代码之后在刷新页面后只会执行一次。
 * axios.defaults.headers.Authorization = `Bearer ${store.getUser().token}`
 */
axios.defaults.transformResponse = [
  (data) => {
    // data json格式的字符串
    // 当后端没有响应的时候  转换会报错  捕获这个错误  处理：不去转换直接返回
    try {
      return JSONBIGINT.parse(data);
    } catch (e) {
      return data;
    }
  },
];

/**
 *  2. 请求拦截器
 */
axios.interceptors.request.use(
  (config) => {
    // 如果token为true
    if (get_token()) {
      if (config && config.data) {
        let data = JSON.parse(JSON.stringify(config.data));
        if (!data.noLoading) {
          show_loading();
        }
      } else {
        show_loading();
      }

      // 不做过多拦截，有token就加上之后return，没有就直接return
      config.headers.Authorization = get_token();
      // config.headers.Uid = get_uid();
      return config;
    }
    return config;
  },
  (err) => {
    hide_loading();
    Promise.reject(err);
  },
);

/**
 *  3. 响应拦截器
 */
axios.interceptors.response.use(
  (res) => {
    // 成功
    hide_loading();
    if (res.status === 200) {
      if (res.data.code === -1) {
        loginExceptionExit(
          "登录状态已过期，您可以继续留在该页面，或者重新登录",
        );
      } else if (
        res.data.code === 200 ||
        res.data.code === 201 ||
        res.data.code === 101 ||
        res.data.code === 100000 ||
        !res.data.code
      ) {
        // 请求成功  - 关闭加载状态
        hide_loading();

        // 如果请求成功 直接返回请求的数据
        return res.data;
      } else {
        // 响应成功但是接口返回错误 - 将错误信息显示出来 - 将加载状态关闭
        hide_loading();
        Message({
          message: res.data.message,
          type: "error",
          duration: 5 * 1000,
        });
        return Promise.reject(new Error(res.data.message || "Error"));
      }
    }
  },
  (error) => {
    // 请求成功  - 关闭加载状态
    let { message } = error;
    hide_loading();
    if (error.response.data.code && error.response.data.code == -1) {
      loginExceptionExit(
        error.response.data.message +
          "权限已过期，您可以继续留在该页面，或者重新登录",
      );
    }
    if (error.response.data.code && error.response.data.code == 557) {
      message = error.response.data.message;
    } else if (error && error.response) {
      error.data = {};
      switch (error.response.status) {
        case 400:
          error.data.msg = "错误请求";
          message = error.data.msg;
          break;
        case 401:
          error.data.msg = "未授权，请重新登录";
          message = error.data.msg;
          break;
        case 403:
          error.data.msg = "拒绝访问";
          message = error.data.msg;
          break;
        case 404:
          error.data.msg = "请求错误,未找到该资源";
          message = error.data.msg;
          break;
        case 405:
          error.data.msg = "请求方法未允许";
          message = error.data.msg;
          break;
        case 408:
          error.data.msg = "请求超时";
          message = error.data.msg;
          break;
        case 500:
          error.data.msg = "服务器端出错";
          message = error.data.msg;
          break;
        case 501:
          error.data.msg = "网络未实现";
          message = error.data.msg;
          break;
        case 502:
          error.data.msg = "网络错误";
          message = error.data.msg;
          break;
        case 503:
          error.data.msg = "服务不可用";
          message = error.data.msg;
          break;
        case 504:
          error.data.msg = "网络超时";
          message = error.data.msg;
          break;
        case 505:
          error.data.msg = "http版本不支持该请求";
          message = error.data.msg;
          break;
        default:
          error.data.msg = `连接错误${error.response.status}`;
          message = error.data.msg;
      }
    } else {
      console.log("message" + message);
      if (message == "Network Error") {
        message = "后端接口连接异常";
      } else if (message.includes("timeout")) {
        message = "系统接口请求超时";
      } else if (message.includes("Request failed with status code")) {
        message = "系统接口" + message.substr(message.length - 3) + "异常";
      }
    }
    Message({
      message: message,
      type: "error",
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  },
);
/**
 * 异常登出方法
 */
function loginExceptionExit(message) {
  // 处理退出登录操作...
  // token失效跳转到登陆页面
  MessageBox.confirm(message, "系统提示", {
    confirmButtonText: "重新登录",
    cancelButtonText: "取消",
    type: "warning",
  }).then(() => {
    // 这一步操作就已经退出了
    window.sessionStorage.clear();
    router.push("/login");
    location.reload();
  });
}

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
export default axios;
